import { Component, Input } from '@angular/core';
import { GraphContainer } from 'src/app/model/generic-graph';

@Component({
  selector: 'app-sbu',
  templateUrl: './sbu.component.html',
  styleUrls: ['./sbu.component.scss']
})
export class SbuComponent {
  @Input() graphData!: GraphContainer;
}
